import type { AllowedGlobals } from './window';

const ROOT_DIRECTORIES = ['/desktop', '/apps', '/MR'];
const rootDirectoryRegex = new RegExp(`(${ROOT_DIRECTORIES.join('|')})`);
export const GAME_VERSION = process.env.GAME_VERSION || '';
export const GAME_TYPE = process.env.GAME_TYPE || '';

export const getStaticBaseUrl = (): { base: string; directory: string } => {
  const fullPath = window.location.origin + window.location.pathname;

  // Split the path by any of the root directories
  const pathParts = fullPath.split(rootDirectoryRegex);

  if (pathParts.length < 2) {
    return { base: window.location.origin, directory: '' };
  } else {
    let directory = pathParts.slice(1).join('');

    if ((window as AllowedGlobals).legacyMode && directory.includes('/main.html')) {
      directory = directory.replace('/main.html', '');
    }

    // if directory has trailing slash, remove it
    const cleanedDirectory = directory.endsWith('/') ? directory.slice(0, -1) : directory;
    return {
      base: pathParts[0] || window.location.origin,
      directory: cleanedDirectory,
    };
  }
};

/**
 * Constructs a static resource URL based on the base URL and game version (if exists).
 * This function takes a resource URL and appends it to the base URL and game version.
 * Use it to get proper static resource URLs for assets, sounds, etc. from public folder
 * if the `GAME_VERSION` is defined (from Webpack config). If `GAME_VERSION` is not defined, it returns the
 * original resource URL.
 *
 * @example getStaticResourceUrl('assets/promotions/promotions.html')
 * @param {string} resourceUrl - The URL of the resource to be appended.
 * @returns {string} The constructed static resource URL or the original resource URL if `GAME_VERSION` is not defined.
 */
export const getStaticResourceUrl = (resourceUrl: string): string => {
  if (!GAME_VERSION || !GAME_TYPE) return resourceUrl;
  const { base } = getStaticBaseUrl();
  return `${base}/apps/${GAME_TYPE}/${GAME_VERSION}/${resourceUrl}`;
};
